<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    paymentLabels: {
      type: Array,
      default: () => []
    },
    paymentData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    paymentLabels() {
      this.renderChart(
        {
          labels: this.paymentLabels,
          datasets: [
            {
              label: "Payments",
              borderColor: "#FC2525",
              pointBackgroundColor: "white",
              borderWidth: 2,
              pointBorderColor: "white",
              backgroundColor: this.gradient,
              data: this.paymentData,
              pointBorderWidth: 1
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          // spanGaps: true,
         
            scales: {
              yAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 0,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
              xAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 10,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
            },
          legend: {
            labels: {
              // This more specific font property overrides the global property
              fontColor: "black"
            }
          }
        }
      );
    }
  },
  data() {
    return {
      gradient: null,
      gradient2: null,
      days: 0,
      daysArray: []
    };
  },
  mounted() {
    // this.days = this.getDays(7, 2012);

    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

    this.renderChart(
      {
        labels: this.paymentLabels,
        
        datasets: [
          {
            label: "Payments",
            borderColor: "#FC2525",
            pointBackgroundColor: "white",
            borderWidth: 2,
            pointBorderColor: "white",
            backgroundColor: this.gradient,
            data: this.paymentData,
            pointBorderWidth: 1
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        spanGaps: true,
         scales: {
              yAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 0,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
              xAxes: [
                {
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(29,140,248,0.0)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    padding: 10,
                    fontColor: "#8898aa",
                    fontSize: 13,
                    fontFamily: "Open Sans",
                  },
                },
              ],
            },
        legend: {
          labels: {
            // This more specific font property overrides the global property
            fontColor: "black"
          }
        }
      }
    );
  },
  methods: {
    getDays(month, year) {
      return new Date(year, month, 0).getDate();
    }
  }
};
</script>
